type FaqItem = {
    question: string;
    answer: string;
};

const faqs: FaqItem[] = [
  {
    question: "Apakah bisa sewa laptop untuk event dadakan di Jakarta, Bogor, Tangerang, atau Bekasi?",
    answer: `
      Tentu bisa. Kami terbiasa handle kebutuhan sewa laptop Jakarta, Bogor, Tangerang, Bekasi hingga sekitarnya secara cepat, bahkan untuk event yang mendadak.<br />
      Laptop siap pakai kami selalu dalam kondisi prima, cocok untuk seminar, pelatihan, tes CPNS, hingga acara kampus atau kantor.<br />
      Tinggal hubungi tim kami, semua akan kami bantu dari proses sampai unit terkirim ke lokasi kamu.
    `,
  },
  {
    question: "Berapa harga sewa laptop di Jakarta dan sekitarnya?",
    answer: `
      Harga sewa laptop Jakarta, Bogor, Tangerang, dan Bekasi bervariasi tergantung pada <strong>spesifikasi laptop</strong> seperti Core i3/i5/i7, <strong>brand seperti ASUS, Lenovo, Dell</strong>, hingga <strong>durasi sewa</strong>.<br />
      Kami juga menawarkan <strong>diskon untuk penyewaan massal atau mingguan</strong>.<br />
      Cukup informasikan lokasi dan kebutuhan kamu, kami bantu hitungkan harga terbaiknya sekarang juga.
    `,
  },
  {
    question: "Apakah bisa request tipe laptop tertentu?",
    answer: `
      Ya, kami menyediakan berbagai tipe laptop untuk disesuaikan dengan kebutuhanmu.<br />
      Mulai dari <strong>laptop ringan untuk kerja remote</strong>, <strong>laptop desain grafis high-end</strong>, <strong>laptop gaming</strong>, hingga <strong>MacBook</strong>.<br />
      Kalau kamu punya spesifikasi tertentu, tinggal request aja, tim kami akan carikan yang paling mendekati.
    `,
  },
  {
    question: "Apakah bisa sewa laptop harian untuk pribadi?",
    answer: `
      Bisa banget. Banyak pelanggan kami dari Jakarta, Bogor, Tangerang, dan Bekasi yang menyewa laptop harian untuk <strong>kerja remote</strong>, <strong>editing video</strong>, bahkan <strong>keperluan traveling kerja</strong>.<br />
      Syaratnya mudah, dan unit bisa langsung dikirim hari itu juga selama masih tersedia.
    `,
  },
  {
    question: "Laptop apa saja yang tersedia untuk disewa?",
    answer: `
      Kami menyediakan laptop dari berbagai brand dan spesifikasi, seperti:<br />
      <ul class="list-disc list-inside ml-4">
        <li>Core i3/i5/i7 dengan RAM 4-16GB</li>
        <li>MacBook Air & Pro</li>
        <li>Lenovo ThinkPad, ASUS, HP EliteBook</li>
        <li>Laptop touchscreen & hybrid</li>
        <li>Laptop gaming (RTX, Ryzen)</li>
        <li>Tablet & Chromebook</li>
      </ul>
      Cukup infokan kebutuhanmu, kami akan match-kan dengan unit yang paling sesuai.
    `,
  },
  {
    question: "Bagaimana kalau laptop rusak saat disewa?",
    answer: `
      Setiap unit kami dilengkapi <strong>garansi teknis penuh</strong> selama masa sewa.<br />
      Jika terjadi kerusakan bukan karena kelalaian, kami akan <strong>ganti unit secepatnya tanpa tambahan biaya</strong>.<br />
      Kami juga punya tim teknisi standby yang siap bantu troubleshooting jarak jauh atau onsite untuk wilayah Jabotabek.
    `,
  },
  {
    question: "Berapa minimum sewa laptop?",
    answer: `
      Durasi minimum sewa adalah <strong>1 hari</strong>. Tapi untuk kamu yang butuh lebih lama (mingguan hingga bulanan), kami siapkan <strong>paket hemat</strong> yang lebih efisien.<br />
      Semakin lama durasi, semakin hemat harganya. Kamu bisa konsultasikan sekarang juga untuk simulasi harga sesuai kebutuhan.
    `,
  },
  {
    question: "Bagaimana cara booking sewa laptop cepat?",
    answer: `
      Proses booking bisa langsung melalui WhatsApp tim kami atau isi form sewa laptop di <a href="https://grasitech.com" class="text-purple-500 underline" target="_blank">grasitech.com</a>.<br />
      Setelah itu, kami akan bantu proses verifikasi & pengiriman sesuai alamat kamu di Jakarta, Bogor, Tangerang, atau Bekasi.<br />
      Pengiriman bisa <strong>hari yang sama</strong> untuk lokasi sekitar Jabotabek.
    `,
  },
  {
    question: "Apakah pengiriman laptop ke Tangerang dan Bekasi dikenakan biaya?",
    answer: `
      Untuk wilayah Jakarta, Bogor, Tangerang, Bekasi, pengiriman laptop rental kami adalah <strong>GRATIS TIS</strong>...*<br />
      Kalau kamu berada di luar area tersebut, akan dikenakan <strong>biaya logistik ringan</strong> tergantung jarak & lokasi.<br />
      Pengiriman dilakukan tepat waktu dan bisa diantar langsung oleh teknisi jika dibutuhkan.
    `,
  },
  {
    question: "Apa saja syarat dan dokumen yang diperlukan?",
    answer: `
      <strong>Untuk penyewaan laptop, berikut dokumen yang kami butuhkan:</strong><br />
      <ol class="list-decimal list-inside space-y-1 mt-2">
        <li>Foto identitas resmi (KTP/NPWP).</li>
        <li>Jika perusahaan: PO / Surat Permintaan Sewa.</li>
        <li>Konfirmasi alamat & nomor aktif yang bisa dihubungi.</li>
        <li>Pembayaran saat unit diterima (COD / Transfer).</li>
        <li>Tim kami berhak menyetujui atau menolak sewa setelah verifikasi.</li>
      </ol>
    `,
  },
];

export default faqs;